import React from 'react';
import { UserCheck, Loader2 } from 'lucide-react';

/**
 * STAND-IN ADVICE ON A GATE (STAND-IN.md §7) — under a Plan / Run gate, what each supervisor's stand-in recommends:
 * "Ana Lima's stand-in (Architect) recommends Approve · 88% — why". The humans still decide (unless the person opted
 * in AND it was a confident Approve — then it says it approved on their behalf). Nothing when no stand-in reviews it.
 */
const TONE = { APPROVE: 'text-emerald-700', DENY: 'text-rose-700', MODIFY: 'text-amber-800' };
const LABEL = { APPROVE: 'Approve', DENY: 'Deny', MODIFY: 'Change it' };

export default function GateAdvice({ reviews, testId = 'gate-advice' }) {
  const rows = (reviews || []).filter((r) => r && r.forName);
  if (!rows.length) return null;
  return (
    <div data-testid={testId} className="mt-1.5 space-y-1">
      {rows.map((r) => (
        <div key={r.forSub} data-testid={`${testId}-${r.forSub}`} className="flex items-start gap-1.5 text-[11.5px] leading-snug text-gray-700">
          <UserCheck className="mt-0.5 h-3.5 w-3.5 shrink-0 text-indigo-500" aria-hidden />
          {r.status === 'reviewing' ? (
            <span className="inline-flex items-center gap-1 italic text-gray-500">
              <Loader2 className="h-3 w-3 animate-spin" aria-hidden />{r.forName}&apos;s stand-in ({r.agentName}) is reviewing…
            </span>
          ) : r.status === 'approved' ? (
            <span><b>Approved on {r.forName}&apos;s behalf</b> by their stand-in ({r.agentName}) · {Math.round(r.confidence * 100)}% sure
              {r.basis ? <span className="text-gray-500"> — {r.basis}</span> : null}</span>
          ) : (
            <span>
              {r.forName}&apos;s stand-in ({r.agentName}) recommends{' '}
              <b className={TONE[r.decision] || ''}>{LABEL[r.decision] || r.decision}</b>
              <span className="tabular-nums"> · {Math.round(r.confidence * 100)}%</span>
              {r.basis ? <span className="text-gray-500"> — {r.basis}</span> : null}
              {r.feedback && r.decision !== 'APPROVE' ? <span className="block text-gray-600">Suggests: {r.feedback}</span> : null}
              {r.status === 'followed' ? <span className="text-emerald-700"> · you agreed</span> : null}
              {r.status === 'overruled' ? <span className="text-gray-500"> · decided otherwise — it learned</span> : null}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
